<template>
    <div class="workout-list container">
        <div class="workout-list__loader" v-if="!workouts">
            <Loader></Loader>
        </div>
        <div class="text" v-if="workouts && workouts.length === 0" v-translate>no_workouts_found</div>
        <WorkoutCard v-for="workout in sortedWorkouts" :key="workout.id" :carddata="workout" v-if="workouts"></WorkoutCard>
    </div>
</template>

<script>
import WorkoutCard from "@/components/WorkoutCard.vue"
import orderBy from 'lodash/orderBy'

export default {
    name: "WorkoutList",
    components: {
        WorkoutCard
    },
    props: {
        workouts: {
            type: [Array, Boolean],
            default: () => {return false},
        },
        sorting: {
            type: String,
            default: 'relevant'
        }
    },
    computed: {
        sortedWorkouts() {
            switch(this.sorting) {
                case 'duration-asc': 
                    return orderBy(this.workouts, ['duration'], ['asc'])
                case 'duration-desc': 
                    return orderBy(this.workouts, ['duration'], ['desc'])
                default:
                    return this.workouts
            }
        }
    }
}
</script>

<style scoped lang="scss">
.workout-list {
    &__loader {
        display: flex;
        justify-content: center;
    }
}
</style>